import createPalette from '@material-ui/core/styles/createPalette';
import paletteValues from './paletteValues';
export default createPalette(paletteValues);
